/**
 * WebView 检测与通信工具
 *
 * 用于检测 Web 应用是否在 React Native WebView 中运行，
 * 以及与原生 App 进行消息通信。
 *
 * 检测方式（任一满足即为 WebView 模式）：
 * 1. window.ReactNativeWebView 存在（react-native-webview 自动注入）
 * 2. URL 参数包含 embed=true（App 端 AuthenticatedWebView 自动追加）
 * 3. URL 参数包含 hideNav=true（App 端 embedMode 追加的第二个参数）
 */

let _isWebView: boolean | null = null

/**
 * 检测当前是否运行在 WebView 中
 * 结果会被缓存，只检测一次
 */
export function isWebView(): boolean {
  if (_isWebView === null) {
    if (typeof window === 'undefined') {
      _isWebView = false
    } else {
      const params = new URLSearchParams(window.location.search)
      _isWebView =
        !!(window as any).ReactNativeWebView ||
        params.get('embed') === 'true' ||
        params.get('hideNav') === 'true'

      if (_isWebView) {
        console.log('[WebView] Detected WebView mode', {
          hasRNWebView: !!(window as any).ReactNativeWebView,
          embedParam: params.get('embed'),
          hideNavParam: params.get('hideNav'),
        })
      }
    }
  }
  return _isWebView
}

/**
 * 向原生 App 发送消息
 * 仅在 WebView 模式下有效
 */
export function postToNative(type: string, data?: Record<string, unknown>): void {
  const rn = (window as any).ReactNativeWebView
  if (rn) {
    rn.postMessage(JSON.stringify({ type, ...data }))
  }
}

/**
 * TypeScript 全局类型扩展
 */
declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void
    }
  }
}
